import FlexContainer from 'components/common/FlexContainer';
import { Fragment } from 'react';
import { RequiredCredential } from 'types/required-credential';
import { getHeadingAndSubHeading } from 'utils/required-credential';
import useFormSchema from 'hooks/use-form-schema';
import useTranslation from 'hooks/use-translation';
type Props = {
  requiredCredentials: RequiredCredential[];
};

export default function RequiredCredentialsSectionSmall(props: Props): JSX.Element | null {
  const { requiredCredentials } = props;
  const formSchema = useFormSchema();
  const translation = useTranslation();

  if (requiredCredentials.length === 0 || !formSchema || !translation) {
    return null;
  }

  return (
    <FlexContainer flexDirection='column' gap={12}>
      {requiredCredentials.map((credential) => {
        const { heading, subHeading, unjoinedHeadings } = getHeadingAndSubHeading(credential, formSchema);
        return (
          <Fragment key={`${heading}${subHeading}`}>
            <span>
              {unjoinedHeadings.map((heading) => (
                <span key={heading.propertyName} className={heading.propertyName}>
                  {heading.value + ' '}
                </span>
              ))}
            </span>
          </Fragment>
        );
      })}
    </FlexContainer>
  );
}
